import Keycloak from 'keycloak-js';
import { hasFailed, isAuthenticated, isPending, setToken } from './state';
import { isNil } from './utils';
let $keycloak = undefined;
export function getKeycloak() {
    return $keycloak;
}
export async function getToken() {
    return updateToken();
}
export async function updateToken() {
    if (!$keycloak) {
        throw new Error('Keycloak is not initialized.');
    }
    try {
        await $keycloak.updateToken(10);
        setToken($keycloak.token);
    }
    catch (error) {
        hasFailed(true);
        throw new Error('Failed to refresh the token, or the session has expired');
    }
    return $keycloak.token;
}
export function createKeycloak(config) {
    $keycloak = new Keycloak(config);
    return getKeycloak();
}
export async function initKeycloak(initConfig) {
    try {
        isPending(true);
        const _isAuthenticated = await $keycloak.init(initConfig);
        isAuthenticated(_isAuthenticated);
        if (!isNil($keycloak.token)) {
            setToken($keycloak.token);
        }
    }
    catch (error) {
        hasFailed(true);
        isAuthenticated(false);
        throw new Error('Could not read access token');
    }
    finally {
        isPending(false);
    }
}
//# sourceMappingURL=keycloak.js.map